function Title({ tlt, smlt }) {
  return (
    <div className="maintitle">
      <h3 className="smalltitle">{smlt}</h3>
      <h2 className="typtitle">{tlt}</h2>
    </div>
  );
}

export default Title;
